// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","453":"03346f77","455":"437debfd","977":"8591a78c"}[chunkId] + ".chunk.js";
};